<div *ngIf="newbutton" class="row">
  <div class="col-12" style="text-align: right">
    <button
      type="button"
      class="btn btn-success"
      (click)="saveEmit('Create', null)"
    >
      <i class="fa fa-plus" aria-hidden="true"></i> &nbsp; New
    </button>
  </div>
</div>

<!--<div style="display: flex; justify-content: flex-end;">

  <button id="custom-table-view" class="gts-btn-primary-outline-actions-start" matRipple>
    <span class="gts-btn-icon">table_view</span>
  </button>

  <button id="custom-pdf-export" class="gts-btn-primary-outline-actions" matRipple>
    <span class="gts-btn-icon">picture_as_pdf</span>
  </button>

  <button id="custom-print" class="gts-btn-primary-outline-actions" matRipple>
    <span class="gts-btn-icon">print</span>
  </button>

  <button id="custom-view-column" class="gts-btn-primary-outline-actions">
    <span class="gts-btn-icon">view_column</span>
  </button>

  <button id="custom-sync" class="gts-btn-primary-outline-actions-end" matRipple>
    <span class="gts-btn-icon">sync_alt</span>
  </button>
  
</div>-->

<button style="visibility: hidden" id="enableReordering"></button>
<button style="visibility: hidden" id="disableReordering"></button>
<div
  style="
    display: flex;
    justify-content: flex-start;
    gap: 10px;
    margin-top: 10px;
  "
>
  <button
    *ngIf="buttonName && buttonClass"
    style="z-index: 3 !important; position: relative !important"
    [class]="buttonClass"
    (click)="handleButtonClick()"
  >
    <span>{{ buttonName }}</span>
  </button>
  <button
    *ngIf="buttonName2 && buttonClass2"
    style="z-index: 3 !important; position: relative !important"
    [class]="buttonClass2"
    (click)="handleButtonClick2()"
  >
    <span>{{ buttonName2 }}</span>
  </button>
</div>
<div class="d-flex justify-content-between" style="margin-top: -20px">
  <div style="/*padding-bottom: 60px;*/" class="">
    <div *ngIf="cleanbulk">
      <button
        [disabled]="!bulk.length"
        class="btn btn-link btn-default btn-just-icon"
        title="Clean Selected"
        (click)="cleanBulk()"
      >
        <i class="material-icons">cleaning_services</i>
      </button>
      Selected items: {{ bulk.length }}
    </div>
  </div>
  <div class="">
    <div *ngIf="!frontpaginate && search">
      <div class="form-group" style="display: inline-flex; position: relative">
        <form class="d-flex">
          <div
            style="
              cursor: pointer;
              max-width: 100px;
              width: -webkit-fill-available;
            "
            *ngIf="esbusqueda"
            (click)="restoreTable()"
            class="text-danger"
          >
            <span class="material-icons">restore</span> Reset Table
          </div>
          <input
            style="margin-left: 10px; padding: 22px"
            type="text"
            placeholder="Search"
            class="form-control"
            id="campoBusquedaForm"
            [ngModelOptions]="{ standalone: true }"
            #campoBusquedaForm="ngModel"
            [(ngModel)]="campoBusqueda"
          />
          <button
            style="margin-left: 10px"
            (click)="goToPage(1)"
            class="btn btn-small btn-info"
          >
            Search
          </button>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- <br *ngIf="!frontpaginate" /><br *ngIf="!frontpaginate" /> -->

<div class="material-datatables">
  <table
    [id]="id"
    class="table display compact table-striped cell-border table-no-bordered table-hover text-center"
    cellspacing="0"
    width="100%"
    style="width: 100%"
    #childScrollElement
    (wheel)="stopPropagation($event)"
  >
    <!--   <ng-container *ngIf="data.rows?.length && data.rows[0][0].getType() === 'checkbox'">
    <colgroup>
      <col style="width: 25px;">
    </colgroup>
  </ng-container> -->
    <thead class="filtros">
      <tr *ngIf="frontpaginate">
        <th
          *ngFor="let title of data.headers; let i = index"
          class="disabled-sorting no-sort"
        >
          <p>{{ title }}</p>
        </th>
      </tr>
      <tr *ngIf="!frontpaginate">
        <th
          *ngFor="let title of data.headers; let i = index"
          [ngClass]="{
            'disabled-sorting no-sort': title === 'check',
            right: title === 'Actions'
          }"
        >
          <div
            *ngIf="title === 'check'"
            style="
              display: flex;
              justify-content: center;
              align-items: center;
              width: 25px !important;
            "
          >
            <mat-checkbox
              *ngIf="!disableAllCheckBox"
              [id]="i"
              [checked]="checkAll()"
              (change)="selectAll()"
              color="warn"
              [disabled]="checkAllGrayed"
            ></mat-checkbox>
          </div>

          <span
            style="font-size: smaller"
            *ngIf="
              title !== 'check' &&
              (!bsort || !sort.includes(i)) &&
              !columnfilters[i]
            "
            [hidden]="columnfilters[i]"
            >{{ title }}</span
          >

          <div
            *ngIf="!frontpaginate && bsort && sort.includes(i)"
            class="column"
            [hidden]="columnfilters[i]"
            style="cursor: pointer !important; margin-top: 25px"
            (click)="ordenar(i)"
          >
            <span>{{ columnfilters[i] ? "" : title }}</span>
            <i
              *ngIf="sortColumn !== i"
              class="fa fa-sort"
              style="margin-left: 5px; font-size: 13px; color: #797d7f"
              aria-hidden="true"
            ></i>
            <i
              *ngIf="sortColumn === i && sortOrder === 'desc'"
              style="margin-left: 5px; font-size: 13px"
              class="fa fa-sort-desc"
              aria-hidden="true"
            ></i>
            <i
              *ngIf="sortColumn === i && sortOrder === 'asc'"
              style="margin-left: 5px; font-size: 13px"
              class="fa fa-sort-asc"
              aria-hidden="true"
            ></i>
          </div>

          <div *ngIf="columnfilters.length">
            <div
              *ngIf="columnfilters[i]"
              class="input-group"
              style="display: flex"
            >
              <mat-form-field
                [id]="i"
                class="example-full-width"
                style="font-size: small; position: relative"
              >
                <mat-label
                  style="
                    font-size: x-small !important;
                    padding-bottom: 5px !important;
                  "
                >
                  {{ columnfilters[i].title }}
                </mat-label>
                <input
                  matInput
                  (keydown)="handleKeyDown($event)"
                  type="text"
                  [name]="columnfilters[i].key"
                  [(ngModel)]="columnfilters[i].value"
                  (keyup.enter)="goToPage(1)"
                  [disabled]="
                    columnfilters[i].type === 'nofilter' ||
                    !columnfilters[i].type_options.length
                  "
                />

                <i
                  *ngIf="columnfilters[i].type_options.length"
                  class="fa fa-filter"
                  aria-hidden="true"
                  style="
                    position: absolute;
                    top: 20px;
                    right: 5px;
                    cursor: pointer;
                    margin-left: 5px;
                    font-size: 13px;
                  "
                  [ngClass]="{
                    purple: columnfilters[i].value,
                    grey: !columnfilters[i].value
                  }"
                  [matMenuTriggerFor]="menu"
                  (contextmenu)="onRightClick($event, columnfilters[i], i)"
                  matTooltip="Left click filters 
   Right click sort"
                  matTooltipClass="multiline-tooltip"
                ></i>
                <mat-menu #menu="matMenu">
                  <button
                    *ngFor="let type_filter of columnfilters[i].type_options"
                    [ngClass]="{
                      'btn-primary fw-bold dark':
                        columnfilters[i].type === type_filter.value
                    }"
                    mat-menu-item
                    (click)="changetypefilter(i, type_filter.value)"
                  >
                    {{ type_filter.name }}
                  </button>
                </mat-menu>
              </mat-form-field>
            </div>
          </div>
        </th>
      </tr>
    </thead>

    <tbody
      (keydown)="onKeydown($event)"
      (focus)="onFocus($event)"
      (blur)="onBlur()"
      (mouseleave)="onMouseLeave()"
      tabindex="0"
    >
      <tr
        *ngFor="let row of data.rows; let j = index"
        (click)="unclick(j, row)"
        (dblclick)="dosclicks(row)"
        [attr.data-id]="row[0].value"
        #rowElement
        [ngClass]="{ 'bg-lumin': selectrow === j }"
        (contextmenu)="rightClick($event, row)"
      >
        <td
          *ngFor="let cell of row; let idx = index"
          [attr.data-label]="data.headers[idx]"
          [ngClass]="{ 'checkbox-class': cell.getType() === 'checkbox' }"
          class="{{ cell.getClass() }}"
          [style]="cell.getTdStyle()"
          (dragover)="enableDrop ? allowDrop($event) : null"
          (drop)="enableDrop ? onDrop($event) : null"
        >
          <div
            [ngSwitch]="cell.getType()"
            [style.text-align]="'start'"
            [style.height]="smallcell ? '21px' : 'auto'"
            [ngStyle]="
              cell.getType() === 'checkbox'
                ? cell.getCheckboxFieldWidth()
                : cell.getStyle()
            "
          >
            <!-- <input *ngSwitchCase="'checkbox'" class="form-check-input" type="checkbox" value="" id="flexCheckDefault"> -->

            <!--
           <mat-checkbox  #checkboxes [attr.data-attr]="cell.value" *ngSwitchCase="'checkbox'" [checked]="isCheck(cell.value)" color="primary" class="checkboxrow" (change)="check(cell.value)" [disabled]="cell.grayed"></mat-checkbox>


          <app-checkbox-dynamic
           *ngSwitchCase="'checkbox'"
            [valueid]="cell.value"
            [isChecked]="isCheck(cell.value)"
           ></app-checkbox-dynamic>
  -->

            <a
              #checkboxes
              *ngSwitchCase="'checkbox'"
              class="btn btn-sm btn-link btn-info btn-just-icon checkboxrow"
              style="margin: 0px"
              [attr.data-attr]="cell.value"
              [attr.data-selected]="cell.selected"
              [attr.disabled]="cell.grayed ? true : null"
            >
              <i
                [attr.data-interno]="cell.value"
                class="checkstyle fa {{
                  isCheck(cell.value) ? 'fa-check-square' : 'fa-square-o'
                }}"
                aria-hidden="true"
              ></i>
            </a>

            <div>
              <!-- <p *ngIf="!cell.value">
                ----
              </p> -->
            </div>
            <div
              *ngSwitchCase="'alert'"
              class="infBox infBox-{{ cell.getColor() }} {{ cell.getClass() }}"
              role="alert"
            >
              <span *ngIf="cell.getIcon() !== ''" class="material-icons">{{
                cell.getIcon()
              }}</span>
              <b>{{ cell.value }}</b>
            </div>

            <button
              *ngSwitchCase="'button'"
              type="button"
              class="btn {{ cell.getClass() }} btn-sm"
              [style]="cell.getStyle()"
              (click)="saveEmit(cell.value, row[0].value)"
            >
              <span *ngIf="cell.getIcon() !== ''" class="material-icons">{{
                cell.getIcon()
              }}</span>
              {{ cell.value }}
            </button>

            <button
              *ngSwitchCase="'action-button'"
              type="button"
              id="{{ cell.getTypeaction() }}-{{ j }}"
              class="btn {{ cell.getClass() }} btn-sm emitirdos"
              [style]="cell.getStyle()"
              (click)="saveEmit(cell.value, row[0].value)"
            >
              <span
                style="z-index: -10"
                *ngIf="cell.getIcon() !== ''"
                class="material-icons"
                >{{ cell.getIcon() }}</span
              >
              {{ cell.value }}
            </button>

            <div
              *ngSwitchCase="'actions'"
              style="text-align: left"
              [style.width]="actionColumnWidth"
            >
              <!-- <button
                *ngFor="let action of cell.value; let n = index"
                class="btn-i btn-link btn-{{ action.color }} btn-just-icon like"
                [title]="action.title ? action.title : action.action"
                >
            </button> -->
              <!-- <i
              *ngFor="let action of cell.value; let n = index"
              class="btn-i btn-link btn-{{ action.color }} btn-just-icon like"
              [title]="action.title ? action.title : action.action"
              class="material-icons emitir"
              id="{{ action.action }}-{{j}}-{{idx}}-{{n}}"
              >{{ action.icon }}</i
              > -->
              <span
                *ngFor="let action of cell.value; let n = index"
                [title]="action.title ? action.title : action.action"
                id="{{ action.action }}-{{ j }}-{{ idx }}-{{ n }}"
                class="material-icons emitir action-{{ action.color }}"
                [matTooltip]="action.tooltip"
              >
                {{ action.icon }}
              </span>
            </div>

            <span
              *ngSwitchCase="'date'"
              class="{{ cell.getClass() }} {{ cell.getColor() }}"
              [style]="cell.getStyle()"
              [matTooltip]="cell.getTooltip()"
              [title]="cell.getTitle()"
            >
              {{ cell.value | date : "MM/dd/yyyy" }}
            </span>

            <div
              *ngSwitchCase="'icon'"
              [style.width]="actionColumnWidth"
              class="{{ cell.getClass() }} {{ cell.getColor() }}"
            >
              <span *ngIf="cell.getIcon() !== ''" class="material-icons">
                {{ cell.getIcon() }}</span
              >
              {{ cell.value }}
            </div>
            <!-- <mat-icon
              *ngSwitchCase="'icon'"
              class="{{ cell.getClass() }} {{ cell.getColor() }}"
              [style]="cell.getStyle()"
              [matTooltip]="cell.getTooltip()"
              [title]="cell.getTitle()"
            >
              {{ cell.value }}
            </mat-icon> -->

            <span
              *ngSwitchCase="'full-date'"
              class="{{ cell.getClass() }} {{ cell.getColor() }}"
              [style]="cell.getStyle()"
              [matTooltip]="cell.getTooltip()"
              [title]="cell.getTitle()"
            >
              {{ cell.value | date : "medium" }}
            </span>

            <span
              *ngSwitchDefault
              class="tooltip-container {{ cell.getClass() }} {{
                cell.getColor()
              }}"
              [style]="cell.getStyle()"
              [attr.data-tooltip]="cell.value"
              style="
                padding: 0px;
                padding-left: 2px;
                display: block;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              <span
                *ngIf="cell.getIcon() !== ''"
                class="material-icons emitir"
                style="vertical-align: middle"
                >{{ cell.getIcon() }}</span
              >
              <span style="vertical-align: middle">{{ cell.value }}</span>
            </span>
          </div>
        </td>
      </tr>
    </tbody>
    <tfoot class="hidden-on-mobile">
      <!--<tr>
        <th
          *ngFor="let title of data.headers; let i = index"  style="padding: 5px !important;"
        > <span style="font-size: x-small;">{{title}}</span>-->
      <!-- <span *ngIf="columnfilters[i]" class="material-icons" style="color: white;">crop_5_4</span>
        <span *ngIf="columnfilters[i]" class="material-icons" style="color: white;">crop_5_4</span>
        <span *ngIf="columnfilters[i]" class="material-icons" style="color: white;">crop_5_4</span>-->
      <!--</th>-->
    </tfoot>
  </table>
</div>

<div *ngIf="!frontpaginate" class="clearfix"></div>
<nav *ngIf="!frontpaginate" aria-label="...">
  <div
    class="mt-1"
    style="display: inline-flex; width: 100%; position: relative"
  >
    <mat-form-field style="max-width: 90px" class="">
      <mat-select
        (selectionChange)="goToPage(1); changeShowing()"
        placeholder="Showing"
        name="showing"
        [(ngModel)]="perPage"
        ariaLabel="itemsPerPageSelected"
      >
        <mat-option value="5">5</mat-option>
        <mat-option value="10">10</mat-option>
        <mat-option value="25">25</mat-option>
        <mat-option value="50">50</mat-option>
        <mat-option value="100">100</mat-option>
        <mat-option value="200">200</mat-option>
        <mat-option value="500">500</mat-option>
        <!--<mat-option value="1000">1000</mat-option>-->
        <!--<mat-option value="ALL">ALL</mat-option>-->
      </mat-select>
    </mat-form-field>
    <p class="mt-5" style="align-self: flex-end; margin-left: 30%">
      Showing {{ showingNav }} to {{ showingTo }} of
      {{ total_items_count }} entries
    </p>

    <ul class="pagination" style="position: absolute; right: 0">
      <div style="display: flex">
        <li class="page-item">
          <a
            (click)="goToPage(1)"
            *ngIf="page > 1"
            class="page-link"
            tabindex="-1"
            >First</a
          >
        </li>
        <li class="page-item">
          <a
            (click)="goToPage(page - 1)"
            *ngIf="page > 1"
            class="page-link"
            tabindex="-1"
            >Previous</a
          >
        </li>
        <li *ngFor="let p of pages" class="page-item">
          <a
            [className]="page == p + 1 ? 'selected-page' : 'page-link'"
            (click)="goToPage(p + 1)"
            >{{ p + 1 }}</a
          >
        </li>
        <li class="page-item">
          <a
            class="page-link"
            *ngIf="page < total_pages"
            (click)="goToPage(page + 1)"
            >Next</a
          >
        </li>
        <li class="page-item">
          <a
            (click)="goToPage(total_pages)"
            *ngIf="page < total_pages"
            class="page-link"
            tabindex="-1"
            >Last</a
          >
        </li>
      </div>
    </ul>
  </div>
</nav>

<script src="src/plug-ins/date-euro.js"></script>
